/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { theme } from 'fpay-ui';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import _ from 'lodash';

import useMovements from '@hooks/useMovements';
import { useAuth } from '@hooks';
import { useBreakpoints } from '@hooks/NewBreakpoint';
import { hideSkeleton, showSkeleton } from '@store/common/actions';
import { fetchAdvancementDetail } from '@store/advancements/actions';

import { getFormatedType, getFormatedSoftDescriptor } from '@helpers/andesUtils';

import FilterMovements from '@components/FilterMovements';
import {
  NotFoundLastMovements,
  NoMoreMovements,
  ErrorTableLastMovements,
  TableSkeletonLastMovements,
  ModalLastMovementsTable,
} from '@components';
import OperationTable from '@components/OperationTable';
import PaginationMov from '@components/PaginationMov';

import { TYPE_MOVEMENT_AUTHORIZATION } from '@constants/transactions';

const Layout = styled.div`
  margin-top: 16px;
`;

const LayoutTable = styled.div`
  width: 100%;
  min-height: 350px;
  margin-bottom: 16px;
  ${theme.breakpoint('md')} {
    margin-top: 80px;
  }
  ${theme.breakpoint('lg')} {
    margin-top: 32px;
  }
`;

const LayoutPagination = styled.div`
  width: 100%;
`;

const LastMovements = () => {
  const { t } = useTranslation();

  const operationHeader = ['FECHA', 'CODIGO', 'TIPO DE MOVIMIENTO', 'DETALLE', 'MONTO'];
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [idToShow, setIdToShow] = useState();
  const [transactionIdToShow, setTransactionIdToShow] = useState();

  const { isSkeleton } = useSelector((state) => state.common) || true;
  const dispatch = useDispatch();

  const { items, getMovements, errorLastMovements } = useMovements();
  const { breakpoint } = useBreakpoints();

  const { merchant, isAllowed } = useAuth();

  const getFondsOutByAuthorization = ({ type, event_date_utc, soft_descriptor, entry_mode }) => {
    switch (type) {
      case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN_ADVANCEMENTS:
        return t('lastMovements.advancementsIn');
      case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN:
        return t('lastMovements.payOrder');
      case TYPE_MOVEMENT_AUTHORIZATION.CARGO_SALDO:
        return t('lastMovements.deferredTransfer');
      case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_OUT:
        return entry_mode
          ? t('lastMovements.creditLineCollection')
          : isAllowed('FOUNDS_BANK_VALIDATION')
          ? setBankDescription(event_date_utc)
          : t('lastMovements.fondsOut');
      case TYPE_MOVEMENT_AUTHORIZATION.INGRESO_DE_SALDO:
      case TYPE_MOVEMENT_AUTHORIZATION.EGRESO_DE_SALDO:
      case TYPE_MOVEMENT_AUTHORIZATION.CANCEL_EGRESO_DE_SALDO:
      case TYPE_MOVEMENT_AUTHORIZATION.CANCEL_INGRESO_DE_SALDO:
      case TYPE_MOVEMENT_AUTHORIZATION.CANCEL_CARGO_SALDO:
        return t('lastMovements.regularizationAdjust');
      case TYPE_MOVEMENT_AUTHORIZATION.PAGO_DE_CUOTA_DE_CREDITO:
        return t('lastMovements.creditInstallmentPayment');
      case TYPE_MOVEMENT_AUTHORIZATION.CANCELACION_DE_PAGO:
        return t('lastMovements.creditInstallmentRefund');

      default:
        return soft_descriptor;
    }
  };

  const setBankDescription = (foDate) => {
    const bank = merchant.bank_accounts.find(
      (b) =>
        b.hasOwnProperty('created_at') &&
        b.hasOwnProperty('updated_at') &&
        ((b.enabled && moment(foDate).isAfter(b.created_at)) ||
          (!b.enabled && moment(foDate).isBetween(b.created_at, b.updated_at)))
    );
    if (!bank) return t('lastMovements.fondsOut');
    const accountNumber = bank?.account_data?.account_number;
    const lastFourDigits = accountNumber && accountNumber.substring(accountNumber.length - 4);
    const accountBank = bank?.bank_data?.finantial_institution_name;
    const accountBankCap = _.startCase(_.camelCase(accountBank));
    return `${t('lastMovements.fondsOutTo')}${accountBankCap}${t(
      'lastMovements.points'
    )}${lastFourDigits}`;
  };

  const handleChangeFilters = (filter) => {
    if (filter?.id) {
      setFilters(filter);
    } else if (filter?.soft_descriptor?.id === 'Orden de pago') {
      setFilters({
        ...filters,
        type: { id: 'Ingreso', name: 'Ingresos', selected: true },
        ...filter,
      });
    } else if (filter?.soft_descriptor?.id === null) {
      setFilters({});
    } else if (filter?.startDate || filter?.endDate) {
      // Cuando solo se cambian las fechas, no forzar ningún tipo de movimiento
      setFilters({
        ...filters,
        ...filter,
      });
    } else if (filter?.soft_descriptor) {
      // Solo forzar tipo 'Egreso' cuando se selecciona un soft_descriptor específico
      setFilters({
        ...filters,
        type: { id: 'Egreso', name: 'Egresos', selected: true },
        ...filter,
      });
    } else {
      setFilters({
        ...filters,
        ...filter,
      });
    }
  };

  const cleanFilters = () => setFilters({});

  const getMovementsFiltered = () =>
    filters.id
      ? items?.filter(({ authorization: { id } }) => id === Number(filters.id))
      : filters.soft_descriptor && filters.soft_descriptor.id === 'Transferencia diferida'
      ? items?.filter(
          ({ authorization: { soft_descriptor } }) =>
            getFormatedSoftDescriptor(soft_descriptor) === filters.soft_descriptor.id
        )
      : filters.soft_descriptor && filters.soft_descriptor.id === 'Retiro de fondos'
      ? items?.filter(({ authorization: { type } }) => type === 'TED CASH OUT')
      : filters.soft_descriptor && filters.soft_descriptor.id
      ? items?.filter(
          ({ authorization: { soft_descriptor, type } }) =>
            getFormatedSoftDescriptor(soft_descriptor) !== 'Transferencia diferida' &&
            type !== 'TED CASH OUT'
        )
      : filters.type && filters.type.id
      ? items?.filter(({ authorization: { type } }) => getFormatedType(type) === filters.type.id)
      : items;

  const toggleModal = () => {
    setIdToShow();
    setTransactionIdToShow();
    setShowModal(!showModal);
  };

  useEffect(() => {
    cleanFilters();
  }, []);

  useEffect(() => {
    dispatch(showSkeleton());
    getMovements(filters);
    setTimeout(() => {
      dispatch(hideSkeleton());
    }, 1000);
    // eslint-disable-next-line
  }, [filters]);

  useEffect(() => {
    if (breakpoint !== 'xs') dispatch(showSkeleton());
    getMovementsFiltered(page);
    setTimeout(() => {
      dispatch(hideSkeleton());
    }, 1000);
    // eslint-disable-next-line
  }, [page]);

  const merchantId = merchant?.sellers?.[0]?.merchant_id;
  const creditorAccountId = merchant?.wallet_info?.creditor_account_id;

  useEffect(() => {
    if (idToShow) {
      setShowModal(true);

      if (idToShow.type === TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN_ADVANCEMENTS) {
        dispatch(fetchAdvancementDetail(merchantId, transactionIdToShow, creditorAccountId));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idToShow]);

  const endMovements = page[1] >= getMovementsFiltered()?.length;
  return (
    <Layout>
      <FilterMovements
        filters={filters}
        handleChangeFilters={handleChangeFilters}
        cleanFilters={cleanFilters}
        optionsSuggest={getMovementsFiltered()?.map((f) => f.authorization.id.toString())}
      />
      {errorLastMovements && (
        <LayoutTable>
          <ErrorTableLastMovements />
        </LayoutTable>
      )}
      {getMovementsFiltered()?.length === 0 && (
        <LayoutTable>
          <NotFoundLastMovements />
        </LayoutTable>
      )}
      {getMovementsFiltered()?.length > 0 && (
        <>
          <LayoutTable>
            {isSkeleton ? (
              <TableSkeletonLastMovements />
            ) : (
              <OperationTable
                dataHeader={operationHeader}
                dataBody={
                  page ? getMovementsFiltered().slice(page[0], page[1]) : getMovementsFiltered()
                }
                properity={[{}, {}, {}, { flex: 'flex' }, { align: 'right' }]}
                setIdToShow={setIdToShow}
                setTransactionIdToShow={setTransactionIdToShow}
              />
            )}
          </LayoutTable>
          <LayoutPagination>
            <PaginationMov
              endScroll={endMovements}
              infinityScroll={page}
              itemsPerPage={breakpoint === 'xs' ? 15 : 10}
              movements={getMovementsFiltered()}
              setData={setPage}
            />
            <br />

            {breakpoint === 'xs' && endMovements && (
              <>
                <NoMoreMovements>Estos son todos los movimientos</NoMoreMovements>
              </>
            )}
          </LayoutPagination>
        </>
      )}
      {showModal && (
        <ModalLastMovementsTable
          open={showModal}
          onClose={toggleModal}
          idToShow={idToShow}
          breakpoint={breakpoint}
          getFondsOutByAuthorization={getFondsOutByAuthorization}
        />
      )}
    </Layout>
  );
};

export default LastMovements;
